import {Dialog, DialogBody, DialogHead} from '@travel-frontend/ui-components';

export type Props = React.PropsWithChildren<{
  visible: boolean;
  fullScreen?: boolean;
  header?: React.ReactNode;
  onClose: () => void;
}>;

export const Overlay: React.FunctionComponent<Props> = ({
  visible,
  fullScreen = false,
  header,
  children,
  onClose,
  ...restProps
}) => {
  return (
    <Dialog
      onClose={onClose}
      open={visible}
      fullScreen={fullScreen}
      {...restProps}
    >
      <DialogHead onClose={onClose}>{header}</DialogHead>
      <DialogBody>{children}</DialogBody>
    </Dialog>
  );
};
